import React from 'react';
import ReactGA from 'react-ga';
import imgUrl from '../../assets/gie-logo-bg-3.jpg';
import GIEList from '../../components/GIEList/GIEList';
import TitleListScreen from '../../components/TitleListeScreen/TitleListScreen';
import OutstandingController from '../../controller/outstanding.controller';
import {DateUtil} from '../../util/date-util';
import GIEButton from '../../components/GIEButton/GieButton';
import userInformations from '../../userInformation/user_informations';
import GIEServicesContainer from "../../components/GIEServicesContainer/GIEServicesContainer";
import NoticeForList from "../../components/GIEList/NoticeForList";

export default class MyOutstanding extends React.Component<any, any> {
  outstandingController: OutstandingController = new OutstandingController();

  constructor(props) {
    super(props);
    this.state = {
      data: []
    }
  }

  componentDidMount() {
    this.getOutStandingList()
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  getOutStandingList = () => {
    const noContract = userInformations.getNoContract();
    if (!noContract?.length) {
      window.location.href = "/admin/login"
    } else {
      this.getData()
    }
  }

  getData = () => {
    this.outstandingController.getOutstandingList().then((data: any) => {
      this.manageData(data);
    }).catch(err => {
      console.log(err)
    })
  }

  manageData = (data: any) => {
    const outstandingList = data.map(line => {
      return {
        _id: line._id,
        number: line.documentNo ? line.documentNo : '',
        title: line.description ? line.description : '',
        date: line.postingDate ? DateUtil.convertDateInString(new Date(line.postingDate)) : '',
        amount: line.remainingAmtLCY ? line.remainingAmtLCY : '',
        customerNo: line.customerNo,
        paid: (!(line.remainingAmtLCY && Number(line.remainingAmtLCY) > 0)),
        visible: true,
        downloadType: line.downloadType
      }
    })
    this.setState({data: outstandingList})
  }

  payBill = () => {
    window.location.href = "https://monetico.apayer.fr/gie/factures";
  }

  render() {
    return (
      <div className="content">
        <GIEServicesContainer imgUrl={imgUrl} title={<TitleListScreen miniTitle="Consultez le détail de votre solde "
                                                                      href="en-cours"
                                                                      title="Votre relevé de situation"/>}>
          <div className="container-xl mb-5">
            <NoticeForList className="mb-3"
              text="Le temps de traitement des paiements est de 1 à 7 jours. Si vous avez réalisé un paiement au cours de cet intervalle, merci de ne pas tenir compte du montant affiché."/>

            <GIEList data={this.state.data} type="outstanding" noData="Vous n’avez pas de solde à régulariser">
              <div className="text-center my-4">
                {!this.state.data.length || Number(this.state.data[0].amount) <= 0 ? null : (
                  <GIEButton onClick={this.payBill} classes={{root: 'blue-btn'}}>Payer mon solde</GIEButton>
                )}
              </div>
            </GIEList>
          </div>
        </GIEServicesContainer>
      </div>
    );
  }
}
